/**
 * Relationship Constants
 * Feature: 004-restore-missing-features
 * Source: specs/004-restore-missing-features/contracts/patient-operations.ts
 */

import type { RelationshipType } from '../types/patient.types'

/**
 * Available relationship types for family members
 * Used in family member forms and displays
 */
export const RELATIONSHIP_OPTIONS: RelationshipType[] = [
  'Pai/Mae',
  'Filho/Filha',
  'Conjuge',
  'Irmao/Irma',
  'Avo/Avo',
  'Neto/Neta',
  'Cuidador',
  'Outro',
]

/**
 * Relationship type labels for display
 * Maps internal values to Portuguese display labels
 */
export const RELATIONSHIP_LABELS: Record<RelationshipType, string> = {
  'Pai/Mae': 'Pai/Mãe',
  'Filho/Filha': 'Filho/Filha',
  'Conjuge': 'Cônjuge',
  'Irmao/Irma': 'Irmão/Irmã',
  'Avo/Avo': 'Avô/Avó',
  'Neto/Neta': 'Neto/Neta',
  'Cuidador': 'Cuidador',
  'Outro': 'Outro',
}

/**
 * Select options for relationship dropdowns
 * Formatted for use with shadcn/ui Select component
 */
export const RELATIONSHIP_SELECT_OPTIONS = RELATIONSHIP_OPTIONS.map((value) => ({
  value,
  label: RELATIONSHIP_LABELS[value],
}))
